import { useState } from 'react';

export const useRefresh = (): [() => void, number] => {
  const [counter, setCounter] = useState(0);
  return [() => setCounter((value) => value + 1), counter];
};
